import {
  USOB_CUSTOMERS_LOADING,
  SUBMIT_USOB_CUSTOMERS_ACTION_DISPATCHER,
  SUBMIT_USOB_CUSTOMERS_ACTION_REQUESTED,
  SUBMIT_USOB_CUSTOMERS_ERROR_DISPATCHER,
} from "./Action";

const initialState = {
  successData: { customers: [], apiData: {} ,customerFilter:[]},
  failureData: {},
  loading: false,
};

const reducer = (state = initialState, action) => {
  const customerList = [];
  const customerFilterOption = [];
  switch (action.type) {
    case SUBMIT_USOB_CUSTOMERS_ACTION_REQUESTED:
      return { ...state, apiLoading: true };
    case SUBMIT_USOB_CUSTOMERS_ACTION_DISPATCHER:
      let data = action.payload.data;
      // console.log("data: ", data);
      data.success.customers.forEach((e) => {
        customerList.push({
          value: e.customer_name,
          id: e.customer_id,
        });
        customerFilterOption.push({
          value: e.customer_name,
          id: e.customer_id,

        });
      });
      customerList.sort(function (a, b) {
        var x = a.value.toLowerCase();
        var y = b.value.toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
      });
      return {
        ...state,
        successData: {
          customers: customerList,
          apiData: data.success.customers,
          customerFilter:customerFilterOption
        },
        loading: false,
      };
    case SUBMIT_USOB_CUSTOMERS_ERROR_DISPATCHER:
      return {
        ...state,
        failureData: action.payload,
        loading: false,
      };
    case USOB_CUSTOMERS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
